$(document).ready(function () {
  
    
  const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
const PART = ['morning', 'afternoon', 'evening']

 


     var counter = 0;
var interval = setInterval(function() {
  
    counter++;
   console.log(counter);
    // Display 'counter' wherever you want to display it.
    if (counter == 4) {
  

    var timetable = window.timetableData;
    const scheduleCard = Vue.component('schedule-card', {
        delimiters: ['${', '}'],
        template: "#schedule-card",
        props: {
            schedule: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                active: false
            };
        },
        computed: {
            startTime() {
                return `${this.schedule.time.start}`
            },
            Title() {
                return `${this.schedule.title}`
            },
            Location() {
                return `${this.schedule.location}`
            },
            Trainer() {
                return `${this.schedule.trainer}`
            }
        },
        watch: {
            active(newVal) {
                this.$emit("card-active", newVal)
            }
        }
    })


    var app = new Vue({
        el: '#app',
        delimiters: ['${', '}'],
        components: {
            'schedule-card': scheduleCard,
        },
        data: {
            schedules: timetable,
            days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
            parts: ['morning', 'afternoon', 'evening'],
            locationFilter: 'all',
            categoriesFilter: 'all',
            isHovered: false
        },
        methods: {
            getDaySchedules(scheudles, day) {
                return scheudles.filter((item) => {
                    return item.day === day
                })
            },
            hoverCard(val) {
                this.isHovered = val
            }
        },
        computed: {
            filteredSchedules() {
                return this.schedules
                    .filter(item => {
                        if (this.locationFilter === 'all') return true
                        return item.location === this.locationFilter
                    })
                    .filter(item => {
                        if (this.categoriesFilter === 'all') return true
                        return item.category.includes(this.categoriesFilter)
                    })

            },
            morningSchedules() {
                return this.filteredSchedules.filter((item) => {
                    return item.time
                        .dayPart === 'morning'
                })
            },
            afternoonSchedules() {
                return this.filteredSchedules.filter((item) => {
                    return item.time
                        .dayPart === 'afternoon'
                })
            },
            eveningSchedules() {
                return this.filteredSchedules.filter((item) => {
                    return item.time
                        .dayPart === 'evening'
                })
            }
        }
    })


    }else if (counter == 5 ) {
           $('.slider-single').slick({
        slidesToShow: 7,
        slidesToScroll: 7,
        arrows: true,
        fade: false,
        adaptiveHeight: true,
        infinite: false,
        useTransform: true,
        speed: 400,
        cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
        responsive: [
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }, {
                breakpoint: 426,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
    });

    $('.slider-nav')
        .on('init', function (event, slick) {
            $('.slider-nav .slick-slide.slick-current').addClass('is-active');
        })
        .slick({
            slidesToShow: 7,
            slidesToScroll: 7,
            dots: false,
            arrows: false,
            focusOnSelect: false,
            infinite: false,
            responsive: [
                              {
                    breakpoint: 1441,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                }, {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }, {
                    breakpoint: 426,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }]
        });

    $('.slider-single').on('afterChange', function (event, slick, currentSlide) {
        $('.slider-nav').slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
        $('.slider-nav .slick-slide.is-active').removeClass('is-active');
        $(currrentNavSlideElem).addClass('is-active');
    });

    $('.slider-nav').on('click', '.slick-slide', function (event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');

        $('.slider-single').slick('slickGoTo', goToSingleSlide);
    });
    
    
  clearInterval(interval);
    }

}, 1000);
  
  
})


